import { Component, OnInit, Inject } from '@angular/core';
import { WsreService } from '../../wsre.service';
import { Photo } from '../../models/wsre.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'photo-popup',
  templateUrl: './photo-popup.component.html',
  styleUrls: ['./photo-popup.component.scss']
})
export class PhotoPopupComponent implements OnInit {
    photo: Photo;
    loadingPhoto: boolean = true;
    photoIsDeleting: boolean = false;
    userCanDeletePhoto = false;
    childId:number|null;
    screenId: number|null;

    constructor(public dialogRef: MatDialogRef<PhotoPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _wsreService: WsreService,
        private _sanitizer: DomSanitizer,
        private _service: NotificationsService) { }

    ngOnInit() {
        this.userCanDeletePhoto = this.data.userCanDeletePhoto;
        this.screenId = this.data.ScreenId;
        if(this.data.childId){
            this._wsreService.getIdlerPartPhoto(this.data.photoId, this.data.photoType,this.data.childId).subscribe(photo => {
                this.photo = photo;
                this.loadingPhoto = false;
            });
        }else{
            this._wsreService.getPhoto(this.data.photoId, this.data.photoType).subscribe(photo => {
                this.photo = photo;
                this.loadingPhoto = false;
            });
        }
        
    }

    getImage(image: string) {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }

    deletePhoto() {
        this.photoIsDeleting = true;
        if(this.data.childId){
        this._wsreService.deleteIdlerPartPhoto(this.data.photoId).subscribe(deleted => {
            if (deleted) {
                this.photoIsDeleting = false;
                this._service.success('Deleted', 'The photo was deleted successfully. ');
                this.dialogRef.close(true);
            } else {
                this.photoIsDeleting = false;
                this._service.error('Failed', 'Failed to delete the photo. ');
            }
        });
    }else{
        this._wsreService.deletePhoto(this.data.photoId, this.data.photoType, this.screenId).subscribe(deleted => {
            if (deleted) {
                this.photoIsDeleting = false;
                this._service.success('Deleted', 'The photo was deleted successfully. ');
                this.dialogRef.close(true);
            } else {
                this.photoIsDeleting = false;
                this._service.error('Failed', 'Failed to delete the photo. ');
            }
        });   
    }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
